import { useQuery } from '@tanstack/react-query';
import { getPackingLists, getPackingListById } from '../services/packingListService';
import { queryKeys } from '../constants/queryKeys';

/**
 * usePackingLists — Fetch paginated packing lists
 * URL: /packing-list?search=...&agentName=...&status=...&page=1&pageSize=20
 */
export const usePackingLists = (page = 1, search = '', agentName = '', status = '') => {
  return useQuery({
    queryKey: queryKeys.packingList.list(page, search, agentName, status),
    queryFn: () => getPackingLists({
      page,
      pageSize: 20,
      search: search || undefined,
      agentName: agentName || undefined,
      status: status || undefined,
    }),
  });
};

/**
 * usePackingList — Fetch a single packing list details by ID
 */
export const usePackingList = (id) => {
  return useQuery({
    queryKey: queryKeys.packingList.detail(id),
    queryFn: () => getPackingListById(id),
    enabled: !!id,
  });
};

